export const USERS_KEY = 'users';
export const VIEW = `${USERS_KEY}/view`;

export const USER_GET_REQUEST = `${USERS_KEY}/USER_GET_REQUEST`;
export const USER_GET_SUCCESS = `${USERS_KEY}/USER_GET_SUCCESS`;
export const USER_GET_ERROR = `${USERS_KEY}/USER_GET_ERROR`;

export const USER_CREATE_REQUEST = `${USERS_KEY}/USER_CREATE_REQUEST`;
export const USER_CREATE_SUCCESS = `${USERS_KEY}/USER_CREATE_SUCCESS`;
export const USER_CREATE_ERROR = `${USERS_KEY}/USER_CREATE_ERROR`;

export const USER_UPDATE_REQUEST = `${USERS_KEY}/USER_UPDATE_REQUEST`;
export const USER_UPDATE_SUCCESS = `${USERS_KEY}/USER_UPDATE_SUCCESS`;
export const USER_UPDATE_ERROR = `${USERS_KEY}/USER_UPDATE_ERROR`;

export const USER_DELETE_REQUEST = `${USERS_KEY}/USER_DELETE_REQUEST`;
export const USER_DELETE_SUCCESS = `${USERS_KEY}/USER_DELETE_SUCCESS`;
export const USER_DELETE_ERROR = `${USERS_KEY}/USER_DELETE_ERROR`;

export const USER_GET_PAYMENT_INFORMATION = `${USERS_KEY}/USER_GET_PAYMENT_INFORMATION`;
export const USER_RENEW_SUBSCRIPTION = `${USERS_KEY}/USER_RENEW_SUBSCRIPTION`;



// WEBPACK FOOTER //
// ./src/store/actions/users.types.js